export const theme = {
  colors: {
    primary: "#3E95B3",
    secondary: "#617D90",
    success: "#4BB543",
    error: "#E93F36",
    text: {
      body: "#023047",
      header: "#023047",
    },
    background: {
      primary: "#fff",
      secondary: "#ecf9ff",
    },
  },
  fonts: {
    body: {
      weights: {
        light: 200,
        regular: 300,
        bold: 700,
      },
    },
    header: {
      fontFamily: "Lato",
      weights: {
        bold: 700,
      },
    },
  },
  space: {
    margin: "1.6rem",
  },
}
